window.Expert = {
	
	subscribe : function(){
		MyWindow.alert('Votre abonnement est terminé, contactez votre expert comptable.');
	}

};